import axios from 'axios'
import { dl } from '../../src/js/core/app'

export const initContactForm = () => {
  const form = document.querySelector('.js-contact-form')
  if (!form) { return false }

  const button = form.querySelector('button')

  form.addEventListener('submit', e => {
    e.preventDefault()
    button.classList.add('is-sending')

    const inputs = form.querySelectorAll('input, select, textarea')
    const params = new window.FormData()
    params.append('action', 'llContactForm')

    for (const input of inputs) {
      const value = input.value
      const name = input.getAttribute('id')
      params.append(name, value)
    }

    axios.post('/wp-admin/admin-ajax.php', params)
      .then(reponse => {
        button.classList.remove('is-sending')
        button.classList.add('is-sent')
        dl.contactForm()

        setTimeout(() => {
          button.classList.remove('is-sent')
          form.reset()
        }, 5000)
      })
      .catch(error => {
        console.log(error)
      })
  })
}
